module.exports = __webpack_public_path__ + "static/media/slider-1.34c6010a.jpg";